// Base URLs for game assets
const ASSET_BASE_URL = 'https://darkorbit-22.bpsecure.com/do_img/global';

// Map IDs
const MAP_IDS = {
  // Normal Maps
  1: { id: 1, name: '1-1' },
  2: { id: 2, name: '1-2' },
  3: { id: 3, name: '1-3' },
  4: { id: 4, name: '1-4' },
  5: { id: 5, name: '2-1' },
  6: { id: 6, name: '2-2' },
  7: { id: 7, name: '2-3' },
  8: { id: 8, name: '2-4' },
  9: { id: 9, name: '3-1' },
  10: { id: 10, name: '3-2' },
  11: { id: 11, name: '3-3' },
  12: { id: 12, name: '3-4' },
  13: { id: 13, name: '4-1' },
  14: { id: 14, name: '4-2' },
  15: { id: 15, name: '4-3' },
  16: { id: 16, name: '4-4' },
  17: { id: 17, name: '1-5' },
  18: { id: 18, name: '1-6' },
  19: { id: 19, name: '1-7' },
  20: { id: 20, name: '1-8' },
  21: { id: 21, name: '2-5' },
  22: { id: 22, name: '2-6' },
  23: { id: 23, name: '2-7' },
  24: { id: 24, name: '2-8' },
  25: { id: 25, name: '3-5' },
  26: { id: 26, name: '3-6' },
  27: { id: 27, name: '3-7' },
  28: { id: 28, name: '3-8' },
  29: { id: 29, name: '4-5' },
  91: { id: 91, name: '5-1' },
  92: { id: 92, name: '5-2' },
  93: { id: 93, name: '5-3' },
  94: { id: 94, name: '5-4' },
  
  // BL Maps
  306: { id: 306, name: '1-BL' },
  307: { id: 307, name: '2-BL' },
  308: { id: 308, name: '3-BL' },
  
  // Galaxy Gates
  430: { id: 430, name: 'Atlas A' },
  431: { id: 431, name: 'Atlas B' },
  432: { id: 432, name: 'Atlas C' },
  433: { id: 433, name: 'Cygni' },
  434: { id: 434, name: 'Helvetios' },
  435: { id: 435, name: 'Eridani' },
  436: { id: 436, name: 'Sirius' },
  437: { id: 437, name: 'Sadatoni' },
  438: { id: 438, name: 'Persei' },
  439: { id: 439, name: 'Volantis' },
  440: { id: 440, name: 'Alcyone' },
  441: { id: 441, name: 'Auriga' },
  442: { id: 442, name: 'Bootes' },
  443: { id: 443, name: 'Aquila' },
  444: { id: 444, name: 'Orion' },
  445: { id: 445, name: 'Maia' },
  42: { id: 42, name: '???' },
  
  // Special Maps
  200: { id: 200, name: 'LoW' },
  203: { id: 203, name: 'Hades' },
  227: { id: 227, name: 'VoT' },
  229: { id: 229, name: 'QZ' },
  466: { id: 466, name: 'Astral' },
  467: { id: 467, name: 'Astral 2' },
  468: { id: 468, name: 'Astral 3' },
  473: { id: 473, name: 'DSE Command' },
  474: { id: 474, name: 'DSE Battle' },
  475: { id: 475, name: 'DSE Battle 2' },
  476: { id: 476, name: 'DSE Unknown 1' },
  477: { id: 477, name: 'DSE Battle 3' },
  478: { id: 478, name: 'DSE Decapitation' },
  479: { id: 479, name: 'DSE Unknown 3' },
  480: { id: 480, name: 'DSE Nebula 1' },
  481: { id: 481, name: 'DSE Nebula 2' },
  482: { id: 482, name: 'World Boss' },
  
  // EBG Maps
  460: { id: 460, name: 'EBG 1' },
  461: { id: 461, name: 'EBG 2' },
  462: { id: 462, name: 'EBG 3' },
  463: { id: 463, name: 'EBG 4' },
  464: { id: 464, name: 'EBG 5' },
  465: { id: 465, name: 'EBG 6' },
  
  // Faction Home Maps
  410: { id: 410, name: 'GoPN' },
  450: { id: 450, name: 'GoPE' },
  
  // Alpha, Beta, Gamma
  51: { id: 51, name: 'Alpha' },
  52: { id: 52, name: 'Beta' },
  53: { id: 53, name: 'Gamma' },
};

/**
 * Get map information by ID
 * @param {number} mapId - The map ID
 * @returns {Object} Map information object with id, name, and displayName
 */
const getMapInfo = (mapId) => {
  return MAP_IDS[mapId] || { id: mapId, name: `Unknown (${mapId})` };
};

// Get map name by ID
const getMapName = (mapId) => {
  const map = MAP_IDS[mapId];
  return map ? map.name : null;
};

// Get rank image URL by rank ID
const getRankImageUrl = (rankId) => {
  return `${ASSET_BASE_URL}/ranks/rank_${rankId}.png`;
};

// Faction IDs and their corresponding data
const FACTIONS = {
  1: {
    id: 1,
    name: 'MMO',
    color: 'error',  // Fallback color
    logoUrl: `${ASSET_BASE_URL}/logos/logo_mmo.png`,
  },
  2: {
    id: 2,
    name: 'EIC',
    color: 'primary',    // Fallback color
    logoUrl: `${ASSET_BASE_URL}/logos/logo_eic.png`,
  },
  3: {
    id: 3,
    name: 'VRU',
    color: 'success',  // Fallback color
    logoUrl: `${ASSET_BASE_URL}/logos/logo_vru.png`,
  },
};

/**
 * Get ship image URL from ship type ID
 * @param {string} typeId - The ship type ID (e.g., 'ship_g-exalted' or 'ship_solace-plus_design_solace-plus-tyrannos')
 * @returns {string} URL to the ship image
 */
const getShipImageUrl = (typeId) => {
  if (!typeId) return '';
  
  // Handle design patterns (e.g., 'ship_solace-plus_design_solace-plus-tyrannos')
  if (typeId.includes('_design_')) {
    const [shipBase, design] = typeId.replace('ship_', '').split('_design_');
    return `${ASSET_BASE_URL}/items/ship/${shipBase}/design/${design}_30x30.png`;
  }
  
  // Standard ship pattern
  const shipId = typeId.replace('ship_', '');
  return `${ASSET_BASE_URL}/items/ship/${shipId}_30x30.png`;
};

/**
 * Get faction information by ID
 * @param {number} factionId - The faction ID to look up
 * @returns {Object} Faction information or UNKNOWN object if not found
 */
const getFactionInfo = (factionId) => {
  return FACTIONS[factionId] || {
    id: factionId,
    name: 'N/A',
    fullName: 'Unknown Faction',
    color: 'default',
  };
};

// Get all unique faction options for filter dropdowns
const getFactionOptions = () => {
  return Object.values(FACTIONS).map(faction => ({
    value: faction.id,
    label: `${faction.name}`,
    color: faction.color
  }));
};

// Format position from server coordinates to game coordinates
const formatPosition = (x, y) => {
  const formatCoord = coord => Math.round(Number(coord) / 100);
  return {
    x: formatCoord(x),
    y: formatCoord(y),
    toString: () => `(${formatCoord(x)}, ${formatCoord(y)})`
  };
};

// Server instance ID to server name mapping
const SERVER_NAMES = {
  151: 'Germany 2',
  392: 'Germany 4',
  46: 'Great Britain',
  674: 'Great Britain 2',
  89: 'Spain',
  48: 'France',
  22: 'Global Europe 1',
  182: 'Global Europe 2',
  277: 'Global Europe 3',
  502: 'Global Europe 5',
  727: 'Global Europe 7',
  1396: 'Global 2 - Ganymede',
  1389: 'Global (PvE)',
  1398: 'Global 3 - Titan',  
  1433: 'Global 4 - Europa',
  1434: 'Global 5 - Callisto (PVE)',
  1442: 'Global 6 - Himalia',
  69: 'Global America',
  257: 'Global America 2',
  755: 'Mexico 1',
  145: 'USA (West Coast)',
  578: 'Poland 3',
  68: 'Russia',
  574: 'Russia 5',
  210: 'Turkey 3',
  387: 'Turkey 4/6',
  577: 'Turkey 5'
};

/**
 * Get server name by instance ID
 * @param {number} serverId - The server instance ID
 * @returns {string} Server name or 'Unknown Server' if not found
 */
const getServerName = (serverId) => {
  return SERVER_NAMES[serverId] || `Server ${serverId}`;
};

// Format last seen timestamp
const formatLastSeen = (timestamp) => {
  if (!timestamp) return 'N/A';
  const date = new Date(timestamp);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
};

export { 
  getFactionInfo, 
  getFactionOptions, 
  formatPosition, 
  formatLastSeen,
  getShipImageUrl,
  getMapName,
  getRankImageUrl,
  getServerName
};

